/**
 * 주어진 수를 지정한 소수점까지 반올림한다.
 * @see https://stackoverflow.com/a/46075337
 * @param number 반올림하려는 숫자
 * @param n 몇 번째 자리까지 반올림할 것인가
 */
export const roundTo = (n: number, num: number): string => {
  return Number.parseFloat((Math.round(num * Math.pow(10, n)) / Math.pow(10, n)).toString()).toFixed(n);
};
